import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useGetMyDetailsQuery } from "../slices/customerSlice";
import { Table } from "react-bootstrap-icons";
import { Col, Row } from "react-bootstrap";

const FavouritesScreen = () => {
  const { userInfo } = useSelector((state) => state.auth);

  const {
    data: myFavData,
    isLoading,
    refetch,
    error,
  } = useGetMyDetailsQuery({ token: userInfo?.token });

  useEffect(() => {
    refetch();
  }, []);

  console.log("myFavData");
  console.log(myFavData);

  const favDetails = myFavData?.[0] || {};
  const favouriteFoodIds = favDetails.favouriteFoods || [];
  const favouriteOutletIds = favDetails.favouriteOutlets || [];

  console.log("favouriteFoodIds");
  console.log(favouriteFoodIds);

  console.log("favouriteOutletIds");
  console.log(favouriteOutletIds);

  return (
    <div style={{ padding: "1rem" }}>
      <h3 style={{ color: "black" }}>My Favourites</h3>

      {/* Food Items Table */}
      <div>
        <h5 style={{ color: "black" }}>Favourite Food Items</h5>
        <div
          style={{
            height: "40vh",
            overflowY: "auto",
            border: "1px solid #ccc",
            borderRadius: "8px",
            marginBottom: "2rem",
          }}
        >
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ backgroundColor: "#f0f0f0" }}>
                <th style={{ padding: "8px", border: "1px solid #ccc" }}>#</th>
                <th style={{ padding: "8px", border: "1px solid #ccc" }}>
                  Food Item ID
                </th>
              </tr>
            </thead>
            <tbody>
              {favouriteFoodIds.map((id, index) => (
                <tr key={id}>
                  <td style={{ padding: "8px", border: "1px solid #ccc" }}>
                    {index + 1}
                  </td>
                  <td style={{ padding: "8px", border: "1px solid #ccc" }}>
                    {id}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Outlet IDs Table */}
      <div>
        <h5 style={{ color: "black" }}>Favourite Outlets</h5>
        <div
          style={{
            height: "40vh",
            overflowY: "auto",
            border: "1px solid #ccc",
            borderRadius: "8px",
          }}
        >
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ backgroundColor: "#f0f0f0" }}>
                <th style={{ padding: "8px", border: "1px solid #ccc" }}>#</th>
                <th style={{ padding: "8px", border: "1px solid #ccc" }}>
                  Outlet ID
                </th>
              </tr>
            </thead>
            <tbody>
              {favouriteOutletIds.map((id, index) => (
                <tr key={id}>
                  <td style={{ padding: "8px", border: "1px solid #ccc" }}>
                    {index + 1}
                  </td>
                  <td style={{ padding: "8px", border: "1px solid #ccc" }}>
                    {id}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default FavouritesScreen;
